import { IonCol, IonHeader, IonIcon, IonItem, IonLabel, IonRow, IonText,IonToggle } from "@ionic/react"
import ProfileImage from "./ProfileImage"
import { location, star, walk, starHalf } from 'ionicons/icons';
import { generateRandomString } from "../services/util";
import { useEffect } from "react";
import StarRatingComponent from 'react-star-rating-component';
import { useState } from 'react';

import useToast from "hooks/useToast";

import { Friend, Users } from "services/api";
import useAuth from "hooks/useAuth";
//import useToast from "hooks/useToast";
import { useContext } from "react";
import { FilterContext } from "State/FilterContext";
import { useIonRouter } from "@ionic/react";
//import MyIcon from '../../src/images/StarBorder.png';

interface UserCardProps {
  user: any,
  type: string
  //resultsList:any
}



const UserCard: React.FC<UserCardProps> = ({ user,type }) => {
  const { userID, token } = useAuth();
  const [sportRank, setSportRank] = useState<any>("");
  const { state, dispatch } = useContext(FilterContext);
  const [check, setCheck] = useState<boolean>(true);
  const router = useIonRouter();
  
  const friendActiveDeactive = async (userId: any, check: any) => {
        try {
          let post = { friends: [{ id: userId, active: check }] };
          //console.log("Post data", post); return;

          let response = await Friend.sendFriendsRequest(post, token ?? "");
          console.log("Response", response.message);
          if (response.success == true) {
            alert(response.message);
            //toast(response.message);
            //toast({ message: "Friend removed successfully" }, true);
          } else {
            //alert("False");
            toast({ message: response.message }, true);
          }
          setCheck(check);
        }
        catch {
          toast({ message: "Something went wrong" }, true);
        }
      }

  console.log("User list", user);
  let user_id = user.id;
  
  // const getSportRankvalue = async (user_id: any) => {
  //   let sportname = localStorage.getItem('sportsintiallySel');
  //   let userID = user_id;
  //   var response = await Users.getUserSportRank(token ?? "",sportname,userID);
  //   let getrankval = response.payload[0].rank;
  //   //console.log("Show rank value", getrankval);
  //   setSportRank(getrankval);
   
  // }



  // const getRankRows = () => {
  //   if (user && user.ranks && Object.keys(user.ranks).map !== undefined) {
  //     return Object.keys(user.ranks).map((rank: string, index: number, array: any[]) => {
  //       return (
  //         <IonRow key={generateRandomString()}>
  //           <IonIcon style={{ marginRight: "5px" }} color="main-text" icon={star} />
  //           <IonText>{(array.length > 1) ? rank : null} Rank: {user.ranks[rank]}</IonText>
  //         </IonRow>
  //       );
  //     })
  //   }
  //   return null;
  // }



  const getRankRows = () => {
    if (user?.sports) {
      return user?.sports.map((sport:any,index: number) => {
        
        return (
          <IonRow key={generateRandomString()}>
            <IonIcon style={{ marginRight: "5px" }} color="main-text" icon={star} />
            {/* <IonText>{(array.length > 1) ? rank : null} Rank: {user.ranks[rank]}</IonText> */}
            <IonText>{localStorage.getItem('sportsintiallySel')}</IonText>
          </IonRow>
        );
      })
    }
    return null;
  }



  const checkUrl = () => {
    if (type== "match_create") {
      return "challenge/create/";
    }else {
      return "/user/friendlist/view/";
    } 
  }

  const handleClick = () => {
     router.push(`${checkUrl()}${user.id}`, 'forward');
  }

  // useEffect(() => {
  //   getSportRankvalue(user_id)
  // }, [token]);
  //console.log("User data", user?.sports[0]?._joinData.rank);
  //console.log("User data", user.id);
  //console.log("selected sports", localStorage.getItem('sportsintiallySel'));

  console.log("Type value", type);

  return (
    <IonItem  >
      <ProfileImage
        icon_type="none"
        size="75px"
        filename={user?.preference?.image ?? ""}
        style={{ marginRight: '15px' }}
      />
      <IonCol onClick={handleClick} style={{ cursor: 'pointer' }}>
        <IonRow>
          {/* <StarRatingComponent
            name="user-rating"
            value={(user && user.rating) ?? 0}
            editing={false}
            starColor={"var(--ion-color-text)"}
            emptyStarColor="#777"
            renderStarIcon={() => <IonIcon icon={star} />}
            renderStarIconHalf={() => <IonIcon icon={starHalf} />}
          /> */}
          
          <IonText style={{background:"transparent", color:"#000", padding:"4px 14px", borderRadius:"5px"}}>
                 {user?.rating.toFixed(1)} 
                 <IonIcon icon={star} style={{color:"#000", marginLeft: "5px", width: "15px"}} /> 
                 
          </IonText>


        </IonRow>
        <IonRow>
          <IonText style={{ fontSize: '18px', paddingBottom: '5px' }}>{user.full_name}</IonText>
        </IonRow>
        {/* {getRankRows()} */}

        <IonRow className="ion-align-items-center">
          <IonCol style={{ maxWidth: '22px' }}>
            <IonIcon style={{ marginRight: "5px", fontSize: '18px' }} color="main-text" icon={location} />
          </IonCol>
          <IonCol>
            <IonRow>
              <IonText style={{ fontSize: '15px' }}>{user?.preference?.location}</IonText>
            </IonRow>
            {/* {(user && user?.preference && user?.preference?.distance_miles !== '') ?
              (<IonRow style={{ paddingTop: '1px' }}>
                <IonText style={{ fontSize: '11px' }}>{user?.preference?.distance_miles?.toFixed(1)} miles away</IonText>
              </IonRow>) : null} */}
          </IonCol>
        </IonRow>
      </IonCol>
      

  
       {/* <IonCol>
           <IonRow>
             <IonText>{localStorage.getItem('sportsintiallySel')}</IonText>&nbsp;&nbsp;
             <IonText>{sportRank}</IonText>
           </IonRow>
       </IonCol> */}

            <IonCol>
              <IonRow>
               <IonText style={{marginLeft: "auto",fontWeight:"bold"}}>Add/Remove Friend</IonText>
              </IonRow>
       
              <IonToggle color="success" style={{marginLeft: "auto",display: "block",marginRight: "16px"}} checked={check} onIonChange={e => friendActiveDeactive(user.id, e.detail.checked)} />   
            </IonCol>
    </IonItem>
  )
}

export default UserCard;

function toast(arg0: { message: any; }, p0: boolean) {
  throw new Error("Function not implemented.");
}
